/*import Swal from 'sweetalert2'*/

/*
    Loaded only in the product page
*/

// Shopify resize image
// https://gist.github.com/DanWebb/cce6ab34dd521fcac6ba

var upload_photo_url = "";

window.resizeImage = (src, size, crop = '') => src.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, '.')
.replace(/\.jpg|\.png|\.gif|\.jpeg/g, (match) => {
    if (crop.length) {
        // eslint-disable-next-line no-param-reassign
        crop = `_crop_${crop}`;
    }
    return `_${size}${crop}${match}`;
});


//Updates the PDP price when a bundle 'variant' selected is higher than the base price
/*
function adjustPDPPriceChange() {
  var priceLabel = document.querySelector(".product__price span[data-price]");//main bundle price object

  if (priceLabel !== null) {
    if (priceLabel.classList.contains("pseudo-bundle-price")){
      var selectElement = document.getElementById("variant-selector");
      var selectedAnimPriceData = selectElement.options[selectElement.selectedIndex].dataset.variantPrice;
      var selectedAnimPrice = Number(selectedAnimPriceData.replace('$', ''));

      var total = selectedAnimPrice + Number(priceLabel.dataset.bundlePrice);
      priceLabel.textContent = "$" + (total % 1 === 0 ? total : total.toFixed(2))
    } else {
      var selectedOption = document.getElementById("variant-selector").options[document.getElementById("variant-selector").selectedIndex];

      if ( selectedOption.getAttribute('data-variant-price') != priceLabel.textContent ) { //if the bundle prices are different
        priceLabel.textContent = selectedOption.getAttribute('data-variant-price');

        
        if ( document.querySelector(".pdp-member-price") !== null) {//if user is member with discount
          var memberPrice = parseFloat(document.querySelector(".product__price span[data-price]").textContent.replace(/[^\d.-]/g, "")) * .75
          document.querySelector(".pdp-member-price").textContent = "$" + memberPrice.toFixed(2)
        }
        
      }

    }
  }

}
  */

//Updates the PDP form's drop down selector for variants and initiates adjustPDPPriceChange()
function swatchSelectUpdate(e){
  var isButton = e.target.nodeName === 'BUTTON';
  if (!isButton){
    return
  }else{
    document.querySelectorAll(".product__color-swatch.selected").forEach((swatch) => {
      swatch.classList.remove("selected");
    })
    e.target.classList.toggle("selected");

    // The `selected` class is paint only — it tells a screen reader nothing.
    // The swatch group is exposed as a radiogroup, so the checked state has to
    // move with the class or the announced selection stays stuck on whichever
    // swatch Liquid rendered as selected. Scoped to the group that was clicked,
    // and to buttons that actually declare role="radio", so swatch markup
    // without the radio semantics (the bundle animal carousel) is left alone.
    var swatchGroup = e.target.closest(".product-form__color-swatches");
    if (swatchGroup) {
      swatchGroup.querySelectorAll('[role="radio"]').forEach((radio) => {
        radio.setAttribute("aria-checked", radio === e.target ? "true" : "false");
      });
    }

    var variantSelector = document.getElementById('variant-selector');

    //variantSelector.value = selectedSwatch.value;
    variantSelector.value = e.target.value;
    if (document.querySelector(".gaf-template #swatchSelection")) {
      let newLabel = document.querySelector(".product__color-swatch.selected").dataset.label;
      document.querySelector(".gaf-template #variantName").textContent = newLabel;
    }
  }
}

//Prevent Default on ATC button
function preventATCDefault() {
  document.querySelector('form[action="/cart/add"]').addEventListener("submit", function(event) {
    event.preventDefault(); // Prevent the default form submission
  
    document.getElementById("myModal").style.display = "block";
  });
  
  // Close the modal when the close button is clicked
  /*document.getElementById("closeModal").addEventListener("click", function() {
    document.getElementById("myModal").style.display = "none";
  });*/

}

function submitATCForm(product) {
  const isGAF = ["GiveAFriend", "GiveAFriend Campaign"].includes(product.type);

  // Get selected variant ID (fall back to first variant)
  let varId;
  const selectedVariant = document.querySelector('select[name="id"] option:checked');
  if (selectedVariant) {
    varId = selectedVariant.value;
  } else {
    varId = product.variants[0].id;
  }

  let formData;

  // GAF products with single variant → submit form directly
  if (product.variants.length <= 1 && isGAF) {
    const gafForm = document.querySelector('form[action="/cart/add"]');
    if (gafForm) gafForm.submit();
    return; // stop here, no AJAX call
  }

  // GAF products with multiple variants → quantity from page
  if (product.variants.length > 1 && isGAF) {
    const qtyEl = document.querySelector("[data-gaf-campaign-qty-text]");
    const quantity = qtyEl ? parseInt(qtyEl.innerText.replace(/(\d+).*/, "$1"), 10) : 1;
    formData = { items: [{ id: varId, quantity }] };

  // All other products
  } else {
    formData = { items: [{ id: varId, quantity: 1 }] };
  }

  // Send to cart
  jQuery.post(`${window.Shopify.routes.root}cart/add.js`, formData, function (data, status) {
    if (status === "success") {
      window.location.href = "/cart";
    }
  }, "json");
}



//Functions/Listeners to add when DOM is loaded
window.addEventListener("load", function() {
  //Adds event listeners to swatches to call swatchSelectUpdate when a new swatch is selected
  if (document.querySelector(".product-form__color-swatches") !== null) {
    document.querySelector(".product-form__color-swatches").addEventListener("click", (event) => {swatchSelectUpdate(event)})
  }

  // Handle bundle variant price descrepancies
  /*if (document.querySelector(".product-form__variants .select-wrapper:not(.upsell-prop-input) select#variant-selector") !== null) {
    document.querySelector(".product-form__variants .select-wrapper:not(.upsell-prop-input) select#variant-selector").addEventListener('change', (event) => {
      adjustPDPPriceChange(event);
    });
  }*/
 //adds eventListeners to zoom upsell photos
  document.querySelectorAll(".upsell-upsell__img-wrapper").forEach((e) => {
    e.addEventListener("click", function() {
      photoZoomFunctionality(e);
    });
  });
});

//API call to retrieve cart information (for testing purposes only)
/*function printCart() {
  jQuery.getJSON('/cart.js', function(cart) {
    //console.log('PRINTCART')
    cart.items.forEach( item => {
      console.log(item)
    })
    console.log("Print cart: ", cart.items);
  });
}*/

/*
function getProdHandleFromURL() {
  const currentURL = window.location.href;
  const regex = /https:\/\/sendafriend\.co\/products\/([^?]+)/;
  
  return currentURL.match(regex)[1];  
}*/

/*API gets item count in cart and updates number in header cart icon*/
function updateCartCount() {
  jQuery.getJSON('/cart.js', function(cart) {
    document.querySelector('span[data-js-cart-count]').textContent = parseFloat(cart.item_count);
  });
}

/*Add upsells to cart the calls addProducts() OLD*/
/*function addUpsells(upsells){
  if(upsells.length > 0){
    let formData = {'items': upsells};
    jQuery.post(window.Shopify.routes.root + 'cart/add.js', formData, function(data, status){
      if(status === "success"){
        addProducts();
      }
    },"json")
  } else {
    addProducts();
  }
}*/

//Fetches JSON for product with given handle (for testing purposes only)
/*function getProductInfo(prodHandle) {
  jQuery.getJSON('/products/' + prodHandle + '.js', function(json) {
    callback(json);
  });
}*/

//Fetches product info given a handle and returns a promise
function getProductInfo(prodHandle) {
  const promise = fetch(window.Shopify.routes.root + 'products/' + prodHandle + '.js')
    .then(response => response.json())
    .catch(error => {
      console.error('Error fetching product info:', error);
      throw error;
    });
  return { promise };
}

//Removes main animal product from cart
function removeAnimFromCart() {
  removeUpsellsViaExiting();
  /*if (document.querySelector(".pseudo-bundle-info") !== null){
    removeBundleAndAnimFromCart()
  } else {
    removeNonBundleFromCart()
  }*/
}

//removes the animal and bundle upsell item for psueo bundle PDPs
function removeBundleAndAnimFromCart() {
  var productHandle = document.getElementById('product__type-data').getAttribute('data-product-handle');
  var notecardText = document.querySelector('.greeting-card_textarea').value;
  var animalHandle = '';
  if (document.querySelector('.product__color-swatch.selected') !== null) {
    var animalHandle = document.querySelector('.product__color-swatch.selected').dataset.animalHandle;
  }
  
  

  jQuery.getJSON('/cart.js', function(cart) {
    var formData = { 'updates': {}};
    
    collectItemInfoCart(cart.items).forEach( item => {
      if (
        (item.handle == productHandle && item.properties['_goes-with-animal'] == animalHandle) ||
        (item.handle == animalHandle && item.properties['Personalized Card'] == notecardText )
      ) {
        var productKey = item.key;
        var productQuantity = item.quantity - 1;

        formData.updates[productKey] = productQuantity;
      }
    })
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      removeUpsellsViaExiting();
      return response.json();
    })
    .catch((error) => {
    });
  });

}

//API call to remove non-bundle (ie animal) products from cart when modal is exited
function removeNonBundleFromCart() {
  var notecardText = document.querySelector('.greeting-card_textarea').value;
  var animalKey = '';
  
  var animalHandle = document.getElementById('product__type-data').getAttribute('data-product-handle')
  var animalQuantity = 0;

  jQuery.getJSON('/cart.js', function(cart) {
    collectItemInfoCart(cart.items).forEach( item => {
      if (item.handle == animalHandle && item.properties['Personalized Card'] == notecardText) {
        var animalKey = item.key;
        var animalQuantity = item.quantity - 1;

        var updates = {}
        updates[animalKey] = animalQuantity;

        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ updates })
        })
        .then(response => {
          removeUpsellsViaExiting();
          //updateCartCount();
          return response.json();
        })
        .catch((error) => {
        });
      }
    })      
  });
}


//Determines if upsell is being added or removed
function updateUpsellCart(elem, prodHandle) {
  if (elem.classList.contains('addUpsell')) {
    addUpsell(elem, prodHandle);
  } else if (elem.classList.contains('removeUpsell')) {
    if (prodHandle == "custom-framed-4x6-photo") {
      removeFileUpload(elem, prodHandle);
    } else {
      removeOneUpsell(elem, prodHandle);
    }
  }
}

//Add upsell to cart
function addUpsell(elem, upsellHandle){
  var { promise } = getProductInfo(upsellHandle);

  promise.then(product => {
    if (product.handle.toLowerCase() == "dont-open-until-sticker") {
      if (verifyDOUNote(elem)) {
        var douTextbox = document.getElementById('DOU_sticker');
        var formData = { 'items': [{
          'id': product.variants[0].id,
          'quantity': 1,
          'properties': {
            'note': douTextbox.value
          }}
        ]}
    
        jQuery.post(window.Shopify.routes.root + 'cart/add.js', formData, function(data, status){
          if(status === "success"){
            elem.classList.replace('addUpsell', 'removeUpsell');
            elem.innerText = "Remove"
            douTextbox.disabled = true;
            updateCartCount();
          }
        },"json")
      }
    } else if (product.id == 7118807990369) { 
      var sizeSelector = document.getElementById("upsell-variant-selector");
      var formData = { 'items': [{
        'id': sizeSelector.value,
        'quantity': 1 }
      ]}
      jQuery.post(window.Shopify.routes.root + 'cart/add.js', formData, function(data, status){
        if(status === "success"){
          elem.classList.replace('addUpsell', 'removeUpsell');
          sizeSelector.disabled = true;
          elem.innerText = "Remove"
          updateCartCount();
        }
      },"json")
    } else if (product.tags.includes("file_upload_product") && upload_photo_url === "") {
      document.querySelector('[id^="filepond--drop-label-"]').click();
      elem.classList.add("uploading");
    } else if (product.tags.includes("file_upload_product")) {
      if (verifyFileUpload(elem)){      
        var formData = { 'items': [{
          'id': product.variants[0].id,
          'quantity': 1,
          'properties': {
            'Photo': upload_photo_url
            }
          }
        ]}
        jQuery.post(window.Shopify.routes.root + 'cart/add.js', formData, function(data, status){
          if(status === "success"){
            elem.classList.replace('addUpsell', 'removeUpsell');
            elem.innerText = "Remove";
            elem.classList.remove("uploading");
            updateCartCount();
          }
        },"json")
      }
    } else {
      var formData = { 'items': [{
        'id': product.variants[0].id,
        'quantity': 1 }
      ]}
      jQuery.post(window.Shopify.routes.root + 'cart/add.js', formData, function(data, status){
        if(status === "success"){
          elem.classList.replace('addUpsell', 'removeUpsell');
          elem.innerText = "Remove";
          updateCartCount();
        }
      },"json")
    }
  });  
}

//Gets the handle, key, quantity, and properties of all items in cart
function collectItemInfoCart(items) {
  var collectedInfo = [];

  items.forEach(function(item) {
    var itemInfo = {
      id: item.variant_id,
      handle: item.handle,
      key: item.key,
      quantity: item.quantity,
      properties: item.properties
    };
    collectedInfo.push(itemInfo);
  });

  return collectedInfo;
}

//Removes upsell from cart
function removeOneUpsell(elem, prodHandle) {
  if (prodHandle == "custom-framed-4x6-photo") {
    removeFileUpload(elem, prodHandle)
  } else {
    jQuery.getJSON('/cart.js', function(cart) {
      var cartItems = collectItemInfoCart(cart.items);
      cartItems.forEach( item => {
        if (item.handle == prodHandle) {
          var id = item.key;
          var quantity = item.quantity - 1;
          var formData = { 'id': id, 'quantity': quantity.toString() }

          jQuery.post(window.Shopify.routes.root + 'cart/change.js', formData, function(data, status){
            if(status === "success"){
              elem.classList.replace('removeUpsell', 'addUpsell');
              elem.innerText = "Add to Package +" + elem.getAttribute("upsell-price");
              
              if (prodHandle.toLowerCase() == 'dont-open-until-sticker') {
                var douTextbox = document.getElementById('DOU_sticker');
                douTextbox.classList.remove('douAdded');
                douTextbox.disabled = false;
              } else if (prodHandle.toLowerCase() == 'someone-loves-you-hoodie-for-human') {
                var sizeSelector = document.getElementById("upsell-variant-selector");
                sizeSelector.disabled = false;
              }
              if (elem.closest("li").classList.contains("fileUploader")){
                if (elem.closest("li").querySelector('.upload-lift input[name="properties[Photo]"]') !== null){
                  elem.closest("li").querySelector(".filepond--action-revert-item-processing").click();
                }
              }
              updateCartCount();
            } else {
            }
          });
        }
      })
    });
  }
}

//Resets the styling for all upsell "Add" buttons when modal is exited
function resetUpsellButtons(buttonList) {
  buttonList.forEach( btn => {
    btn.classList.replace('removeUpsell', 'addUpsell');
    btn.innerText = "Add to Package +" + btn.getAttribute("upsell-price");
  
    //var lowercaseClasses = Array.from(btn.closest("li").classList).map(className => className.toLowerCase());
    var lowercaseClasses = btn.closest("li").classList[0];
    if (lowercaseClasses == 'dont-open-until-sticker') {
      var douTextbox = document.getElementById('DOU_sticker');
      douTextbox.classList.remove('douAdded');
      douTextbox.disabled = false;
    }
  })

}

//Removes all upsells from cart if exiting upsell modal
function removeUpsellsViaExiting() {
  var upsellsToRemove = [];

  document.querySelectorAll(".upsell-upsell__add-rmv-btn.removeUpsell").forEach( upsell=> {
    upsellsToRemove.push(upsell.closest("li").classList[0])
  })

  if (upsellsToRemove.length > 0){
    jQuery.getJSON('/cart.js', function(cart) {
      var updates = {}
      collectItemInfoCart(cart.items).forEach( item => {
        if (upsellsToRemove.includes(item.handle.toLowerCase())) {
          var upsellKey = item.key;
          var upsellQuantity = item.quantity - 1;

          updates[item.id] = item.quantity - 1;
          
        }
      })      
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates })
      })
      .then(response => {
        resetUpsellButtons(document.querySelectorAll(".upsell-upsell__add-rmv-btn.removeUpsell"))
        updateCartCount();
        return response.json();
      })
      .catch((error) => {
      });
    });
  } else {
    updateCartCount();
  }
}

/* Shows/hides the upsells in modal according to selected size */
function updateUpsellsForAnimSize(){
  //get selected size
  let selectedSize = document.querySelector('div.size-selector_wrapper div.selected')
  //if it is not the original size
  if(!selectedSize.classList.contains('original')){
    //hide the upsells in the no sell list
    document.querySelectorAll('li.upsellHide').forEach(e => {
      e.setAttribute('id','upsellHide');
    })
  }else{//it's the original and we need to remove any #upsellHide
    document.querySelectorAll('li.upsellHide').forEach(e => {
      e.removeAttribute('id');
    })
  }
}

/*----------- Upload-lift START -----------*/
//Checks if file is finished uploading and creates error message
function verifyFileUpload(elem) {
  const errorElem = elem.parentElement.querySelector('.customization_error');

  if (upload_photo_url.length >= 4) {
    errorElem.text = "";
    errorElem.setAttribute('aria-label', "");
    errorElem.style.display = 'none';

    return true;
  } else {
    const errorMsg = "Please upload a photo before adding this to your package";
    errorElem.innerHTML = errorMsg;
    errorElem.setAttribute('aria-label', errorMsg);
    errorElem.style.color = "#C1272F";
    errorElem.style.display = 'block';
    
    return false;
  }
}

function removeFileUpload(elem, prodHandle, photoURL) {

  if (!photoURL) {
    photoURL = upload_photo_url;
  }

  jQuery.getJSON('/cart.js', function(cart) {
    var cartItems = collectItemInfoCart(cart.items);
    cartItems.forEach(item => {
      if (item.handle == prodHandle && item.properties['Photo'] == photoURL) {
        var id = item.key;
        var quantity = item.quantity - 1;
        var formData = { 'id': id, 'quantity': quantity.toString() };

        jQuery.post(window.Shopify.routes.root + 'cart/change.js', formData, function(data, status) {
          if (status === "success") {
            elem.classList.replace('removeUpsell', 'addUpsell');
            elem.innerText = "Add to Package +" + elem.getAttribute("upsell-price");

            if (elem.closest("li").classList.contains("fileUploader")) {
              const revertBtn = elem.closest("li").querySelector(".filepond--action-revert-item-processing");
              if (revertBtn) {
                revertBtn.click();
              }
            }
            updateCartCount();
          } 
        });
      }
    });
  });
}

/*----------- Upload-lift END -----------*/

//Checks if DOU stickers are filled out correctly
function verifyDOUNote(douBtn) {
  // Find the nearest upsell container for this button
  var container = douBtn.closest('li');
  if (!container) return false; // safety fallback

  // Find the input and error message inside this container
  var douTextbox = container.querySelector('#DOU_sticker');
  var errorElement = container.querySelector('.customization_error');
  
  if (!douTextbox || !errorElement) return false; // safety fallback

  var value = douTextbox.value.trim();

  if (value === '' || value === "Please add a date.") {
    douTextbox.classList.add('douError');
    errorElement.classList.add('error');
    errorElement.textContent = "Please add a date.";
    //errorElement.style.display = 'block';
    return false;
  } else {
    douTextbox.classList.remove('douError');
    douTextbox.classList.add('douAdded');
    errorElement.classList.remove('error');
    errorElement.textContent = "";
    //errorElement.style.display = 'none';
    return true;
  }
}


function photoZoomFunctionality(elem) {
  let parent = elem.closest(".upsell-item-top")
  parent.classList.toggle("zoom-upsell");
}
